module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer__finance"
  }, [_c('div', {
    staticClass: "md-layout"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-33 pr"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "type", $$v)
      },
      expression: "filter.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Тип (все)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Приход")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Расход")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-33 pr"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.operation_type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "operation_type", $$v)
      },
      expression: "filter.operation_type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Тип операции (все)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Поручение")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Заявка")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-33"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.company_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "company_id", $$v)
      },
      expression: "filter.company_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Получатель (все)")]), _vm._v(" "), _vm._l((Object.values(_vm.companies)), function(c) {
    return _c('option', {
      key: ("customer__finance-company-" + (c.id)),
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-50 pr"
  }, [_c('z-date', {
    attrs: {
      "no-margin": "",
      "reset": "",
      "return-string": false,
      "format": "DD.MM.YYYY",
      "type": "date",
      "placeholder": "Дата от"
    },
    model: {
      value: (_vm.filter.date_from),
      callback: function($$v) {
        _vm.$set(_vm.filter, "date_from", $$v)
      },
      expression: "filter.date_from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('z-date', {
    attrs: {
      "no-margin": "",
      "reset": "",
      "return-string": false,
      "format": "DD.MM.YYYY",
      "type": "date",
      "placeholder": "Дата до"
    },
    model: {
      value: (_vm.filter.date_to),
      callback: function($$v) {
        _vm.$set(_vm.filter, "date_to", $$v)
      },
      expression: "filter.date_to"
    }
  })], 1)]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "table-id": "customer-operations",
      "noFooter": "",
      "link": "",
      "linkTarget": "_blank",
      "noBreackColumns": ['datetime', 'sum', 'balance_coming', 'balance_consumption', 'balance_sum_before', 'balance_sum_after'],
      "refreshOnCreate": false,
      "defaultSort": "datetime",
      "defaultOrder": "asc"
    },
    on: {
      "refresh": _vm.refreshOperations
    },
    scopedSlots: _vm._u([{
      key: "company_id",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.company ? scope.item.company.name : ''))]
      }
    }, {
      key: "payment_method_id",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.payment_method ? scope.item.payment_method.name : ''))]
      }
    }, {
      key: "datetime",
      fn: function(scope) {
        return [(scope.item && scope.item.date) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.moment(scope.item.date).format("DD.MM.YY")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.moment(scope.item.date).format("HH:mm:ss")))])]) : _vm._e()]
      }
    }, {
      key: "operation_type",
      fn: function(scope) {
        return [(parseInt(scope.item.operation_type) === 1) ? _c('span', {
          staticClass: "customer__finance-table-value-item finance"
        }, [_vm._v("Поручение")]) : _vm._e(), _vm._v(" "), (parseInt(scope.item.operation_type) === 2) ? _c('span', {
          staticClass: "customer__finance-table-value-item deal"
        }, [_vm._v("Заявка")]) : _vm._e(), _vm._v(" "), (parseInt(scope.item.operation_type) === 3) ? _c('span', {
          staticClass: "customer__finance-table-value-item balance"
        }, [_vm._v("Сальдо")]) : _vm._e()]
      }
    }, {
      key: "number",
      fn: function(scope) {
        return [_c('div', [_c('div', [_vm._v(_vm._s(scope.item.number ? scope.item.number : '--'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(scope.item.ones_id ? scope.item.ones_id : '--'))])])]
      }
    }, {
      key: "sum",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.priceFormat(scope.item.sum)))]
      }
    }, {
      key: "balance_coming",
      fn: function(scope) {
        return [(parseInt(scope.item.type) === 1) ? _c('span', {
          staticClass: "customer__finance-table-value-item plus"
        }, [_vm._v(_vm._s(_vm.priceFormat(scope.item.sum)))]) : _c('span', [_vm._v(_vm._s(_vm.priceFormat(0)))])]
      }
    }, {
      key: "balance_consumption",
      fn: function(scope) {
        return [(parseInt(scope.item.type) === 2) ? _c('span', {
          staticClass: "customer__finance-table-value-item minus"
        }, [_vm._v(_vm._s(_vm.priceFormat(scope.item.sum)))]) : _c('span', [_vm._v(_vm._s(_vm.priceFormat(0)))])]
      }
    }, {
      key: "balance_sum_before",
      fn: function(scope) {
        return [(_vm.filter.company_id) ? _c('div', {
          class: {
            'customer__finance-table-value-item minus': scope.item.company_balance_before && parseFloat(scope.item.company_balance_before.sum) < 0,
            'customer__finance-table-value-item plus': scope.item.company_balance_before && parseFloat(scope.item.company_balance_before.sum) > 0,
          }
        }, [_vm._v(_vm._s(scope.item.company_balance_before ? _vm.priceFormat(scope.item.company_balance_before.sum) : 0))]) : _c('div', {
          class: {
            'customer__finance-table-value-item minus': scope.item.balance_before && parseFloat(scope.item.balance_before.sum) < 0,
            'customer__finance-table-value-item plus': scope.item.balance_before && parseFloat(scope.item.balance_before.sum) > 0,
          }
        }, [_vm._v(_vm._s(scope.item.balance_before ? _vm.priceFormat(scope.item.balance_before.sum) : 0))])]
      }
    }, {
      key: "balance_sum_after",
      fn: function(scope) {
        return [(_vm.filter.company_id) ? _c('div', {
          class: {
            'customer__finance-table-value-item minus': scope.item.company_balance_after && parseFloat(scope.item.company_balance_after.sum) < 0,
            'customer__finance-table-value-item plus': scope.item.company_balance_after && parseFloat(scope.item.company_balance_after.sum) > 0,
          }
        }, [_vm._v(_vm._s(scope.item.company_balance_after ? _vm.priceFormat(scope.item.company_balance_after.sum) : 0))]) : _c('div', {
          class: {
            'customer__finance-table-value-item minus': scope.item.balance_after && parseFloat(scope.item.balance_after.sum) < 0,
            'customer__finance-table-value-item plus': scope.item.balance_after && parseFloat(scope.item.balance_after.sum) > 0,
          }
        }, [_vm._v(_vm._s(scope.item.balance_after ? _vm.priceFormat(scope.item.balance_after.sum) : 0))])]
      }
    }]),
    model: {
      value: (_vm.operationsFiltered),
      callback: function($$v) {
        _vm.operationsFiltered = $$v
      },
      expression: "operationsFiltered"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customer__finance__footer"
  }, [_c('table', {
    staticClass: "entity-card-footer"
  }, [_c('tr', _vm._l((_vm.tableColumns), function(field, i) {
    var _obj;

    return _c('td', {
      key: ("customer__finance__footer-field-" + (field.field) + "-" + i),
      class: ( _obj = {
        'customer__finance__footer-item': true
      }, _obj[("footer-item__" + (field.field))] = true, _obj ),
      style: (("width: " + (field.width)))
    }, [(field.field == 'payment_method_id') ? _c('div', [_vm._v("Сальдо")]) : (field.field == 'balance_coming') ? _c('div', [(parseInt(_vm.totalSum.type) === 1) ? _c('span', {
      staticClass: "customer__finance-table-value-item plus"
    }, [_vm._v(_vm._s(_vm.priceFormat(_vm.totalSum.sum)))]) : _c('span', [_vm._v(_vm._s(_vm.priceFormat(0)))])]) : (field.field == 'balance_consumption') ? _c('div', [(parseInt(_vm.totalSum.type) === 2) ? _c('span', {
      staticClass: "customer__finance-table-value-item minus"
    }, [_vm._v(_vm._s(_vm.priceFormat(_vm.totalSum.sum)))]) : _c('span', [_vm._v(_vm._s(_vm.priceFormat(0)))])]) : (field.field == 'balance_sum_before') ? _c('div', {
      class: {
        'customer__finance-table-value-item minus': _vm.totalSum.balance_before && parseFloat(_vm.totalSum.balance_before.sum) < 0,
        'customer__finance-table-value-item plus': _vm.totalSum.balance_before && parseFloat(_vm.totalSum.balance_before.sum) > 0,
      }
    }, [_vm._v(_vm._s(_vm.totalSum.balance_before ? _vm.priceFormat(_vm.totalSum.balance_before.sum) : 0))]) : (field.field == 'balance_sum_after') ? _c('div', {
      class: {
        'customer__finance-table-value-item minus': _vm.totalSum.balance_after && parseFloat(_vm.totalSum.balance_after.sum) < 0,
        'customer__finance-table-value-item plus': _vm.totalSum.balance_after && parseFloat(_vm.totalSum.balance_after.sum) > 0,
      }
    }, [_vm._v(_vm._s(_vm.totalSum.balance_after ? _vm.priceFormat(_vm.totalSum.balance_after.sum) : 0))]) : _vm._e()])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ab928c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/components/CustomerFinance.vue
// module id = 1023
// module chunks = 0